import { useQuery } from "@tanstack/react-query";
import { InterfaceReward } from "../types/types";
import { reward } from "../products/reward";

export function useGetAllRewards(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<InterfaceReward>({
      queryKey: ["getAllRewards"],
      queryFn: () => reward.GetAllReward(option),
    });

  return {
    data,
    isLoading,
    error,
    status,
    isSuccess,
    refetch,
  };
}
